import SearchCompanyIcon from '../../../assets/images/icons/search-company-icon.svg?react'
import SearchIcon from '../../../assets/images/icons/search-lg.svg?react'

type SearchValueProps = {
  searchValue: string
  setSearchValue: any
}

function NoSitesFound({ searchValue, setSearchValue }: SearchValueProps) {
  return (
    <div className="flex flex-col pb-8">
      <div className="pb-8">
        <div className="flex flex-col container mx-auto ">
          <div className="flex justify-center items-center pt-12">
            <div className="flex flex-col items-center">
              <SearchCompanyIcon />
              <span className="font-medium text-xl text-gray-900 pb-2 pt-5">
                No sites found
              </span>
              <p className="pb-8 w-96 text-center font-normal text-base text-gray-500">
                Your search “{searchValue}” did not match any sites. Please try
                again.
              </p>
              <button
                onClick={() => {
                  setSearchValue('')
                }}
                className="border border-solid border-gray-300 rounded-lg shadow-sm py-2.5 px-4"
              >
                <span className="font-medium text-base text-gray-700">
                  Clear search
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoSitesFound
